import React, { PureComponent } from 'react';
import url from 'url';
import SearchBarView from './SearchBarView';
import {
    fetchAddress,
    fetchCurrentLocation,
    formQueryObject,
} from '../../../utils';

class SearchBarContainer extends PureComponent {
    render() {
        const extendedProps = {
            ...this.props,
            fetchCurrentAddress,
            redirectToSearch,
        };

        return (<SearchBarView {...extendedProps} />);
    }
}

const fetchCurrentAddress = async () => {
    try {
        const location = await fetchCurrentLocation();
        return await fetchAddress(location);
    } catch (err) {
        return '';
    }
};

const redirectToSearch = (parameters = {}) => {
    const query = formQueryObject(parameters);

    window.location.assign(
        url.format({
            pathname: '/search',
            query,
        })
    );
};

export default SearchBarContainer;
